@if (Error) {
  <mj-empty-state Variant="error" Title="Couldn't load Resources" [Message]="Error"><div actions><button type="button" mjButton variant="primary" (click)="Refresh()">Try again</button></div></mj-empty-state>
} @else if (NoSeason) {
  <mj-empty-state Variant="empty" Title="OEP is between seasons" Message="There is no active OEP season yet. We will email you when your role opens." />
} @else if (!Loading) {
<section class="oep-res">
  <!-- markup.html:911-913 -->
  <h1 class="oep-res__h1">Resources</h1>
  <p class="oep-res__sub">{{ Sub }}</p>
  <div class="oep-res__groups">
    @for (g of Groups; track g.Role) {
      <section class="oep-res__group">
        <div class="oep-res__head">
          <oep-role-chip [Role]="g.Role" />
          <span class="oep-res__window">{{ g.Window }}</span>
        </div>
        @if (g.Items.length === 0) {
          <p class="oep-meta">{{ NoGuidance }}</p>
        } @else {
          <ul class="oep-res__items">
            @for (i of g.Items; track $index) {
              <li class="oep-res__li"><a class="oep-res__item" [href]="i.Url" target="_blank" rel="noopener"><span class="oep-res__kind">{{ i.Kind }}</span><span class="oep-res__title">{{ i.Title }}</span><span class="oep-res__note">{{ i.Note }}</span><span class="oep-sr"> (opens in a new tab)</span></a></li>
            }
          </ul>
        }
      </section>
    }
  </div>
</section>
}
